import axios from 'axios';

const basePath = '/web-api/checkouts';

export const computeDiscount = (payload, config = {}) => {
    return axios.post(
        basePath + '/compute-discount',
        payload,
        config
    );
}

export const checkFreeShipping = (payload, config = {}) => {
    return axios.post(
        basePath + '/check-free-shipping',
        payload,
        config
    );
}

export default {
    computeDiscount,
    checkFreeShipping
}